import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    branchList: [],

    isLoadingGetDriversInBranchArea: false,

    focusedBranch: null,

    hoveredUser: null,
 
    isListView: false,

    filterDurationHour: 480,
    filterDurationDay: 20,
    
    constantFilterDurationHour: 480,
    constantFilterDurationDay: 20,

    filterDurationType: 2,

};

const staticLocationData = [
  {
    lat: 38.4242766,
    name: "İzmir"
  },
  {
    lat: 41.1905043,
    name: "Çorlu"
  },
  {
    lat: 40.7993121,
    name: "Gebze"
  },
  {
    lat: 40.1969063,
    name: "Bursa"
  },
  {
    lat: 40.1083314,
    name: "Ankara"
  },
  {
    lat: 38.7566917,
    name: "Kayseri"
  },
  {
    lat: 37.9317415,
    name: "Konya"
  }
]

export const getDriversInBranchArea = createAsyncThunk("boundaries/GetDriversInBranchArea", async({duration}, thunkApi)=> {
  try {

      const {data} = await axiosInstance.get(`${process.env.REACT_APP_API_URI}/BranchUserLocations/GetDriversInBranchArea?Duration=${duration}`)
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})

const branchUserLocationsSlice = createSlice({
  name: "branchUserLocations",
  initialState,
  reducers: {


    setFocusedBranch: (state, action) => {
      state.focusedBranch = action.payload
    },

    setHoveredUser: (state, action) => {
      
      state.hoveredUser = action.payload
    },

    setIsListView: (state, action) => {
      if(action.payload === true || action.payload === false){
        state.isListView = action.payload
      }
      else{
        state.isListView = !state.isListView
      }
    },

    updateFilterDuration: (state,action) => {

      const {type, data} = action.payload

      if(type === 1){
          state.filterDurationHour = data
          state.constantFilterDurationHour = data
      }
      else{
          state.filterDurationDay = data
          state.constantFilterDurationDay = data
      }
  },


  updateFilterDurationType: (state,action) => {
      state.filterDurationType = action.payload
      state.filterDurationHour = ""
      state.filterDurationDay = ""
  },

  },
  extraReducers: (builder) => {
    builder
      //! getLocationSearchResult
      .addCase(getDriversInBranchArea.pending, (state) => {
        state.isLoadingGetDriversInBranchArea = true;
      })
      .addCase(getDriversInBranchArea.fulfilled, (state, action) => {
        state.isLoadingGetDriversInBranchArea = false;
        state.branchList = action.payload.data.$values.map(item => {
          return {
            ...item,
            branchName: staticLocationData?.find(itm => itm.lat === item.branchCoords.$values[0].latitude),
            centerCoords: {lat: item.branchCoords.$values[0].latitude, lng: item.branchCoords.$values[0].longitude}
          }
        })
      })
      .addCase(getDriversInBranchArea.rejected, (state) => {
        state.isLoadingGetDriversInBranchArea = false;
      })

  },
});

export const {
    setFocusedBranch,
    setHoveredUser,
    setIsListView,
    updateFilterDurationType,
    updateFilterDuration
} = branchUserLocationsSlice.actions;
export default branchUserLocationsSlice.reducer;
